module.exports = __webpack_public_path__ + "h5/img/menu1.cfbc8a59.png";